import { render } from "./dialog-change-password.vue?vue&type=template&id=7390ebcc"
import script from "./dialog-change-password.vue?vue&type=script&lang=js"
export * from "./dialog-change-password.vue?vue&type=script&lang=js"

import exportComponent from "/home/ctis-desenvolvimento/Projetos/front-end/piso-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__